import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router";
import { useHistory } from "react-router-dom";
import { client } from "../../../App";
import {
  getEvictionForMutation,
  VERIFY_UPDATED_EMAIL,
} from "../../../helpers/mutations";
import Loader from "../../common/Loader/Loader";
import Modal from "../../common/Modal/Modal";

const ConfirmPopup = (props) => {
  return (
    props.isOpen && (
      <Modal
        show={true}
        description={props.t("validate.email.error.text")}
        type={"link"}
        linkTitle={props.t("validate.email.error.button.text")}
        to={"/login"}
        styleType={"primary"}
      />
    )
  );
};
function useQuery() {
  return new URLSearchParams(useLocation().search);
}
const ValidateEmailPage = () => {
  const history = useHistory();
  const [isOpen, setIsOpen] = useState(false);
  let params = useQuery();
  let token = params.get("token");
  const { t } = useTranslation();
  console.log(token);
  useEffect(() => {
    if (token) {
      client()
        .mutate({
          mutation: VERIFY_UPDATED_EMAIL,
          variables: { token },
          update: (cache) => {
            const fieldsToEvict = getEvictionForMutation("verifyUpdatedEmail");
            fieldsToEvict.forEach((field) => cache.evict({ fieldName: field }));
            cache.gc();
          },
        })
        .then((outcome) => {
          console.log(outcome, "activation ok");
          history.push("/login");
        })
        .catch((err) => {
          setIsOpen(true);
          console.error(err);
        });
    } else {
      setIsOpen(true);
    }
    // eslint-disable-next-line
  }, []);
  return <>{isOpen ? <ConfirmPopup isOpen={isOpen} t={t} /> : <Loader />}</>;
};

export default ValidateEmailPage;
